module.exports = __webpack_public_path__ + "img/AB.3b02498a.png";